import { useUserVerified } from '@flecto/auth'
import {
  useMutationSetupOnboarding,
  useQueryGetUserLogged,
} from '@flecto/core/shared'

import { useFormContext } from '../components/FormOnboarding/FormOnboarding'
import type {
  CoreCountryCode,
  CoreEmployeeSize,
  CoreFlectoInterests,
  CoreMigratingSystems,
} from '@flecto/types'

export function useOnboardingActions() {
  const { isUserOnboarded } = useUserVerified()
  const form = useFormContext()
  const { mutateAsync: setupOnboardingMutation } = useMutationSetupOnboarding()

  const saveAllDataOnboarding = async () => {
    if (isUserOnboarded) {
      return
    }

    const user = form.getValues().step_basic_info
    const business = form.getValues().step_business_info
    const { address } = form.getValues().step_location
    const fullName = `${user.first_name} ${user.last_name}`

    const payload = {
      user: {
        full_name: fullName,
        legal_name: fullName,
        business_name: user.company_name,
        business_category_id: Number(business.business_category),
      },
      user_address: {
        main: true,
        legal: true,
        label: 'Main address',
        address_label: 'Main address',
        address_street: address.address_street || '',
        address_city: address.address_city || '',
        address_country_code: address.address_country_code as CoreCountryCode,
        address_country_name: address.address_country_name,
        address_region: address.address_region,
        address_postal_code: address.address_postal_code || '',
      },

      business: {
        employee_size: user.qty_employees as CoreEmployeeSize,
        booking_monthly_avg:
          business.avg_bookings_per_month as CoreEmployeeSize,
        flecto_interests:
          business.flecto_products_interested_on as CoreFlectoInterests[],
        migrating_systems:
          business.systems_to_replace as CoreMigratingSystems[],
      },
    }

    await setupOnboardingMutation(payload)
  }

  return saveAllDataOnboarding
}
